import selfie from '../../assets/about_me_photo.jpg'
import './About.css';

export default function About() {
    return (
        <div id="about">
            <h2 className="col-md-12 section-heading text-center wow fadeInUp">About me</h2>
            <div className='about-content'>
                <div className="col-lg-6 my-auto text-center wow fadeIn" data-wow-delay="0.4s" id="profilePhotoContainer">
                    <img className="img-fluid w-120" src={selfie} alt="A level and GCSE maths tutor in Doncaster" id="profilePhoto" />
                </div>
                <div className="wow fadeIn about-text-content" data-wow-delay="0.4s">
                    <p>Hi, I'm Andy Kent. Whilst I have had a successful career as a senior manager in law enforcement I always maintained a keen interest in maths after studying the subject at King's College, London. I tutored maths to my sons and niece at GCSE and A level and all achieved A*'s and went on to study a maths related degree at a Russell Group university. During this period, and without advertising, I was inundated with requests for tutoring from other parents. I took on a few, but within a short period I had a sizeable waiting list. It is at this point I decided to become a full time maths tutor; a job I love.</p>
                </div>
            </div>
        </div>
    );
};
